require('./src/ng-array-filter-browserify');
module.exports = 'ng-array-filter';
